module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Dashboard/DashboardPages/System settings/general-settings/general-settings.component.scss
// module id = ./src/app/Dashboard/DashboardPages/System settings/general-settings/general-settings.component.scss
// module chunks = main